import React from "react";
import { Link, NavLink } from "react-router-dom";
import Vector from "../assets/Logo.js";
import Common, { getCommonDa } from "./../Common";
import Cookies from "js-cookie";
import action from "../Actions";
import { connect } from "react-redux";
import { Overlay, OverlayTrigger, Tooltip } from "react-bootstrap";

class SideMenu extends Common {
  constructor(props) {
    super(props);
    var has_local_data = this.getFromStorage("encdata") ? 1 : 0;
    var localdata = has_local_data
      ? this.decrypt(this.getFromStorage("encdata"), 0)
      : "";
    this.state = {
      isLoggedIn: false,
      hr_permission: "",
      localdata: localdata,
      apiUrl: this.decryptconfigdata("apiUrl"),
      cookie_token: Cookies.get("token"),
      active_board: [],
      userdetails: "",
      linkCheck: "",
      app_token: "",
    };
  }

  componentDidUpdate = (prevProps, prevState) => {
    const app_token = this.getFromStorage("app_token");
    if (this.props !== prevProps) {
      this.setState(
        (state) => {
          return {
            ...state,
            active_board: this.props.boards?.active_boards,
            linkCheck: this.props.link ? this.props.link : "",
          };
        },
        () => {
          this.setActiveMenu();
        }
      );
    }
  };

  getBoardCall = () => {
    this.props.allBoards(this.state.app_token);
  };
  async componentDidMount() {
    // this function is calling to set the active menu in sidebar
    this.setActiveMenu();

    // fetch all data from local storage like app_token, user_uuid etc...
    //where we have this function in common.js files
    try {
      const data = this.getCommonData();
      if (data) {
        if (this.props.boards.active_boards.length > 0) {
          return;
        } else {
          this.setState({ ...this.state, app_token: data.app_token }, () => {
            this.props.allBoards(this.state.app_token);
          });
        }
      }
    } catch (e) {
      console.log(e.message);
    }
  }

  componentWillMount = async () => {
    // this method will call whenever we change any thing in code or any change in DOM otherwise we can
    // manage using componentDidMount
    try {
      let isLoggedin = await this.checklogion();
      if (isLoggedin == true) {
        this.setState({
          isLoggedIn: true,
        });
      }
    } catch (e) {
      console.log(e.message);
    }
  };

  // set the active menu in sidebar function
  setActiveMenu = () => {
    const boards = this.state.active_board;
    const path =
      window.location.pathname.split("/")[
        window.location.pathname.split("/").length - 1
      ];

    boards &&
      boards.forEach((bo) => {
        if (bo.attribute_set_key === path) {
          this.setState({ ...this.state, linkCheck: bo.attribute_set_key });
        }
      });
  };
  get_short_name = (name) => {
    if (name.includes(" ")) {
      const words = name.split(" ");
      return words.map((word) => word.charAt(0)).join("");
    } else {
      return name.substring(0, 2);
    }
  };
  // this function is for list all board name in side menu
  getAllBoardList = () => {
    try {
      const allBoard =
        this.state.active_board?.length > 0 &&
        this.state.active_board.map((board, index) => (
          <OverlayTrigger
            key={index}
            placement={"right"}
            overlay={
              <Tooltip id={`tooltip-${board.attribute_set_name}`}>
                <strong>{board.attribute_set_name}</strong>
              </Tooltip>
            }
          >
            <div
              className={`card dropend mu-dropdown mt-3 ${
                this.state.linkCheck === board.attribute_set_key ? "active" : ""
              }`}
              key={index}
            >
              <NavLink
                to={{
                  pathname: `/tattle/${board.attribute_set_key}/${
                    board.attribute_set_type == 4 ? "kanban" : "list"
                  }`,
                  state: { data: board },
                }}
                exact
              >
                <div className="card-header">
                  <div
                    className={`muBtn _light subitem-dropdownnew `}
                    data-bs-toggle="tooltip"
                    data-bs-placement="right"
                    data-bs-original-title="ER"
                    style={{ backgroundColor: board.color }}
                  >
                    {this.get_short_name(board.attribute_set_name)}
                  </div>
                </div>
              </NavLink>
            </div>
          </OverlayTrigger>
        ));

      return allBoard;
    } catch (e) {
      console.log(e.message);
    }
  };

  render() {
    return (
      <div className="cms-child sidebar cms-tattle-sidebar">
        <div className="sliding-panel-wrap">
          <div className="cmsNav main-nav active" id="sideMenu_iconOnly">
            {this.state.isLoggedIn == true && (
              <>
                <div className="panel-header pt-3 ps-4 d-none">
                  <div className="brand flex-fill">
                    <svg
                      width="71"
                      height="29"
                      viewBox="0 0 71 29"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M4.1821 0.869951C6.34471 0.293254 8.50733 1.735 10.2374 2.74422C14.2743 5.19518 19.032 7.50197 22.4922 10.6738C24.2223 12.4039 25.2315 14.8549 23.2131 16.8733C22.2039 17.8825 20.0413 15.8641 19.1762 15.2874C16.1486 13.4131 13.2651 11.5388 10.2374 9.66458C9.08402 8.94371 7.64228 7.79031 6.34471 9.08788C4.90297 10.818 7.06558 12.1155 8.36315 12.9806C10.9583 14.7107 13.6976 16.2966 16.2927 18.0267C16.8694 18.315 18.8879 19.1801 18.8879 19.9009C19.032 20.3335 18.4553 20.6218 18.167 20.766C17.4461 21.1985 16.0044 22.4961 15.1393 22.3519C13.2651 21.9194 11.1025 19.9009 9.51655 18.8917C8.36315 18.1709 7.06558 17.7383 6.20054 19.0359C4.7588 21.1985 8.36315 22.6403 9.66072 23.5053C10.0932 23.6495 11.2466 24.2262 11.1025 24.8029C11.1025 25.2354 10.2374 25.5237 9.94907 25.6679C8.79567 26.3888 7.49811 27.1097 6.20054 27.398C3.02871 28.1189 1.44279 25.8121 1.01027 23.0728C0.145225 17.8825 0.145225 11.8272 0.721922 6.63692C1.15444 4.33013 1.29862 1.44665 4.1821 0.869951Z"
                        fill="#0EBAFA"
                      ></path>
                      <path
                        d="M42.5644 14.1304C42.5644 16.2574 42.037 17.8921 40.9823 19.0347C39.9277 20.1773 38.4159 20.7486 36.4472 20.7486C34.4784 20.7486 32.9667 20.1773 31.912 19.0347C30.8573 17.8921 30.33 16.2515 30.33 14.1128C30.33 11.9742 30.8573 10.3423 31.912 9.2173C32.9726 8.08644 34.4902 7.52101 36.4648 7.52101C38.4394 7.52101 39.9482 8.08937 40.9911 9.22609C42.04 10.3628 42.5644 11.9976 42.5644 14.1304ZM33.1864 14.1304C33.1864 15.566 33.4589 16.647 34.0038 17.3736C34.5487 18.1001 35.3632 18.4634 36.4472 18.4634C38.621 18.4634 39.7079 17.0191 39.7079 14.1304C39.7079 11.2359 38.6269 9.78859 36.4648 9.78859C35.3808 9.78859 34.5634 10.1548 34.0126 10.8873C33.4618 11.6138 33.1864 12.6949 33.1864 14.1304ZM58.0669 20.5728H54.604L49.0141 10.8521H48.935C49.0464 12.5689 49.102 13.7935 49.102 14.5259V20.5728H46.6675V7.72316H50.104L55.685 17.3472H55.7466C55.6587 15.6773 55.6147 14.4966 55.6147 13.8052V7.72316H58.0669V20.5728ZM70.1504 20.5728H62.75V7.72316H70.1504V9.95558H65.4746V12.7769H69.8252V15.0093H65.4746V18.3228H70.1504V20.5728Z"
                        fill="#303049"
                      ></path>
                    </svg>
                  </div>
                </div>
                <div className="panel-body">
                <div className="tattle_logo">
                    <NavLink to="/board/list">
                      <svg
                            width="35"
                            height="35"
                            viewBox="0 0 120 131"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                       d="M25.1707 10.3843C33.9116 8.05346 47.6615 16.9188 54.6543 20.9979C70.9709 30.9041 85.3157 38.6908 100.648 50.4836C107.723 56.3802 114.998 65.6166 105.364 75.2491C101.286 79.3282 101.785 79.9387 98.2887 77.6081C86.4957 70.5316 61.9817 54.4369 49.7446 46.8618C45.0825 43.9481 39.3214 41.0491 34.6048 45.7661C31.0667 54.0213 37.6162 56.4219 42.8607 59.9183C53.3499 66.9111 63.0333 71.7948 73.5227 78.7867C75.8809 80.359 87.6748 86.4871 87.6748 89.4009C88.2574 91.1493 81.7643 95.8943 80.5985 96.4765C77.6852 98.2249 74.9696 101.194 71.1637 100.015C63.0413 97.4969 54.2549 89.9419 47.8447 85.8632C42.2377 82.2948 36.0513 84.6837 34.872 85.8632C30.1547 90.5803 34.2196 94.6448 34.872 95.297C35.7112 96.1363 56.4153 107.118 55.8326 109.449C55.8326 111.197 49.9223 114.763 48.7567 115.346C44.0952 118.259 41.0286 118.898 35.7841 120.063C22.964 122.977 15.1249 116.983 13.3768 105.911C9.88035 84.9336 8.95328 55.6022 11.2842 34.6245C13.0323 25.301 13.5161 12.7152 25.1707 10.3843Z"
                       fill="#006EFA"
                     />
                      </svg>
                    </NavLink>
                  </div>
                  <div className="accordion" id="cms-nav-accordion">
                    <OverlayTrigger
                      key={"allboard"}
                      placement={"right"}
                      overlay={
                        <Tooltip id={`tooltip-allboard`}>
                          <strong>All Boards</strong>
                        </Tooltip>
                      }
                    >
                      <div
                        className={`card dropend mu-dropdown ${
                          this.state.linkCheck === "list" ? "active" : ""
                        }`}
                      >
                        <NavLink to="/board/list" exact>
                          <div className="card-header">
                            <div
                              className="muBtn _light"
                              title=""
                              data-bs-toggle="tooltip"
                              data-bs-placement="right"
                              data-bs-original-title="Tattle Boards"
                            >
                              <div className="iconText">
                                <div className="svg">
                                  <svg
                                    width="18"
                                    height="18"
                                    viewBox="0 0 18 18"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M2.25 6.75L9 1.5L15.75 6.75V15C15.75 15.3978 15.592 15.7794 15.3107 16.0607C15.0294 16.342 14.6478 16.5 14.25 16.5H3.75C3.35218 16.5 2.97064 16.342 2.68934 16.0607C2.40804 15.7794 2.25 15.3978 2.25 15V6.75Z"
                                      stroke="#8C9196"
                                      strokeWidth="1.33"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    ></path>
                                    <path
                                      d="M6.75 16.5V9H11.25V16.5"
                                      stroke="#8C9196"
                                      strokeWidth="1.33"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    ></path>
                                  </svg>
                                </div>
                              </div>
                            </div>
                          </div>
                        </NavLink>
                      </div>
                    </OverlayTrigger>

                    <hr className="mt-3 mb-3" />
                    {this.getAllBoardList()}
                    {Number(getCommonDa().is_admin) ? (
                      <OverlayTrigger
                        key={"user"}
                        placement={"right"}
                        overlay={
                          <Tooltip id={`tooltip-user`}>
                            <strong>User</strong>
                          </Tooltip>
                        }
                      >
                        <div className={`card dropend mu-dropdown mt-3`}>
                          <NavLink to={{ pathname: `/tattle/users` }} exact>
                            <div className="card-header">
                              <div
                                title=""
                                className={`muBtn _light ${
                                  this.state.linkCheck === "users"
                                    ? "active"
                                    : ""
                                }`}
                              >
                                <div className="iconText">
                                  <div className="svg">
                                    <svg
                                      width="18"
                                      height="19"
                                      viewBox="0 0 18 19"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M15 16.3525V14.8525C15 14.0568 14.6839 13.2938 14.1213 12.7312C13.5587 12.1685 12.7956 11.8525 12 11.8525H6C5.20435 11.8525 4.44129 12.1685 3.87868 12.7312C3.31607 13.2938 3 14.0568 3 14.8525V16.3525"
                                        stroke="#8C9196"
                                        strokeWidth="1.33"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      ></path>
                                      <path
                                        d="M9 8.85248C10.6569 8.85248 12 7.50933 12 5.85248C12 4.19562 10.6569 2.85248 9 2.85248C7.34315 2.85248 6 4.19562 6 5.85248C6 7.50933 7.34315 8.85248 9 8.85248Z"
                                        stroke="#8C9196"
                                        strokeWidth="1.33"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      ></path>
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </NavLink>
                        </div>
                      </OverlayTrigger>
                    ) : (
                      ""
                    )}
                    {/* {Number(getCommonDa().is_admin) ? (
                      <OverlayTrigger
                        key={"customer"}
                        placement={"right"}
                        overlay={
                          <Tooltip id={`tooltip-customer`}>
                            <strong>Customer</strong>
                          </Tooltip>
                        }
                      >
                        <div className={`card dropend mu-dropdown mt-3`}>
                          <div className="card-header">
                            <div
                              className={`muBtn _light ${
                                this.state.linkCheck === "customers"
                                  ? "active"
                                  : ""
                              }`}
                              data-bs-toggle="tooltip"
                              data-bs-placement="right"
                              data-bs-original-title="Customers"
                            >
                              <div className="iconText">
                                <div className="svg">
                                  <NavLink
                                    to={{ pathname: `/tattle/customers` }}
                                    exact
                                  >
                                    <svg
                                      width="18"
                                      height="19"
                                      viewBox="0 0 18 19"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M12.75 16.3525V14.8525C12.75 14.0568 12.4339 13.2938 11.8713 12.7312C11.3087 12.1685 10.5456 11.8525 9.75 11.8525H3.75C2.95435 11.8525 2.19129 12.1685 1.62868 12.7312C1.06607 13.2938 0.75 14.0568 0.75 14.8525V16.3525"
                                        stroke="#8C9196"
                                        strokeWidth="1.33"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      ></path>
                                      <path
                                        d="M6.75 8.85248C8.40685 8.85248 9.75 7.50933 9.75 5.85248C9.75 4.19562 8.40685 2.85248 6.75 2.85248C5.09315 2.85248 3.75 4.19562 3.75 5.85248C3.75 7.50933 5.09315 8.85248 6.75 8.85248Z"
                                        stroke="#8C9196"
                                        strokeWidth="1.33"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      ></path>
                                      <path
                                        d="M17.25 16.3525V14.8525C17.2495 14.1877 17.0283 13.542 16.621 13.0167C16.2138 12.4913 15.6436 12.1161 15 11.95"
                                        stroke="#8C9196"
                                        strokeWidth="1.33"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      ></path>
                                      <path
                                        d="M12 2.94995C12.6453 3.11518 13.2173 3.49048 13.6257 4.01668C14.0342 4.54289 14.2559 5.19007 14.2559 5.8562C14.2559 6.52233 14.0342 7.16951 13.6257 7.69572C13.2173 8.22193 12.6453 8.59723 12 8.76245"
                                        stroke="#8C9196"
                                        strokeWidth="1.33"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      ></path>
                                    </svg>
                                  </NavLink>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </OverlayTrigger>
                    ) : (
                      ""
                    )} */}
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loginsInfo: state.loginDetails,
    boards: state.allBoards,
    link: state.attributes.link,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loginData: (inputs) => {
      dispatch(action.loginDetails(inputs));
    },
    keepNameBoard: (inputs) => {
      dispatch(action.keepAllNameAndKey(inputs));
    },
    allBoards: (inputs) => {
      dispatch(action.fetAllBoards(inputs));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SideMenu);
